import React from 'react'
import {
    FieldErrors,
    FieldValues,
    Path,
    UseFormRegister,
} from 'react-hook-form'

type Props<TFormData extends FieldValues> = {
    id: Path<TFormData>
    name: string
    placeholder: string
    register: UseFormRegister<TFormData>
    errors: FieldErrors<TFormData>
    rows?: number // Add rows parameter to control visible lines
}

function TextArea<TFormData extends FieldValues>({
    id,
    name,
    placeholder,
    register,
    errors,
    rows = 3, // Default to 3 lines if not provided
}: Props<TFormData>): React.JSX.Element {
    return (
        <div className="mb-4">
            <label
                htmlFor={id}
                className="block text-sm font-bold mb-1 text-gray-700"
            >
                {name}
            </label>
            <textarea
                id={id}
                placeholder={placeholder}
                rows={rows} // Use the rows parameter
                {...register(id)}
                className={`form-textarea w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                    errors[id] ? 'border-red-500' : 'border-gray-300'
                }`}
            />
            {errors[id] && (
                <p className="text-red-500 text-sm mt-1">
                    {errors[id].message?.toString()}
                </p>
            )}
        </div>
    )
}

export default TextArea
